export default __webpack_public_path__ + "8f765a88c60265794d96184bcabe2f04.svg";